import styled from 'styled-components';

export const Button = styled.div<{ hasTooltip?: boolean }>`
  width: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  & .dropdown {
    background-color: ${(props) => props.theme.colors.dropdownBackground};
    margin: 0;
    padding: 0;
    padding-right: 15px;
    position: absolute;
    right: 15px;
    top: 30px;
    /* width: 100px; */
    width: ${(props) => props.hasTooltip ? '190px' : '100px'};
    border-radius: 5px;
    box-shadow: ${(props) => props.theme.shadows.modalShadow};
    z-index: 1;

    li {
      color: ${(props) => props.theme.colors.textPrimary};
      list-style-type: none;
      width: 100%;
      text-align: right;
      font-size: 12px;
      padding-top: 5px;
      padding-bottom: 5px;
      padding-right: 15px;
      cursor: pointer;

      :hover {
        background-color: ${(props) => props.theme.colors.dropdownHover};
      }
    }
  }
`;

export const Img = styled.div`
  svg {
    fill: ${props => props.theme.colors.TooltipBorder};
    width: 20px;
    height: 20px;
  }
`;

export const Tooltip = styled.div`
  display: inline-flex;
  justify-content: space-between;
  gap: 10px;

  .tooltip {
  position: relative;
  display: inline-block;
  }

  .tooltip .tooltiptext {
  visibility: hidden;
  width: 160px;
  background-color: ${props => props.theme.colors.TooltipBackground};
  color: ${props => props.theme.colors.TooltipText};
  border-color: ${props => props.theme.colors.TooltipBorder};
  text-align: center;
  padding: 5px;
  font-family: Roboto, sans-serif;
  font-weight: bold;
  font-size: 11px;
  text-align: right;
  letter-spacing: 0.18px;
  border: 1px solid;
  border-radius: 10px 0px 10px 10px;

  position: absolute;
  z-index: 1;
  top: 100%;
  left: 450%;
  margin-left: -250px;

  opacity: 0;
  transition: opacity 0.3s;
  }

  .tooltip:hover .tooltiptext {
    visibility: visible;
    opacity: 1;
  }
`;